import React, { useState , useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import DeleteConfirmation from "../../General/DeleteConfirmation";
import { showSuccess, showError,showWarning} from "../../General/Toast"; 


function ConvertToSsle({clientData, role}) {
 const navigate = useNavigate();
 const [searchTerm, setSearchTerm] = useState('');
 const[fetchEstimate,setFetchEstimate] = useState([]);
     const [selectedParty, setSelectedParty] = useState(null);
         const [showTxn, setShowTxn] = useState(false);
      const [showDelete, setShowDelete] = useState(false); 
      
      
      const [showConvertModal, setShowConvertModal] = useState(false);
const [selectedTransaction, setSelectedTransaction] = useState(null);

const [convertPayable, setConvertPayable] = useState("");
const [convertReceived, setConvertReceived] = useState("");
const [convertDue, setConvertDue] = useState("");

      const fetchEstimateHis = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-estimate-bill/${clientData.id}`);
     
      const sortedData = [...res.data].sort((a, b) => b.invoiceNo - a.invoiceNo);

    setFetchEstimate(sortedData);
     
    } catch (error) {
      console.log(error);
    }
  };   

   useEffect(() => {
     fetchEstimateHis();
  
    }, []);


 const handleOpenConvertSale = (item) => {
  setSelectedTransaction(item);

  // You can leave these empty because you want
  // to enter them manually.
  setConvertPayable("");
  setConvertReceived("");
  setConvertDue("");

  setShowConvertModal(true);
};
   

    const filteredData = Array.isArray(fetchEstimate)
  ? fetchEstimate
      .filter((itm) =>
        Object.values(itm).some((val) =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
      )
  : [];



const handleConvertToSale = async () => {
  try {
    if (!selectedTransaction) return;

    const payable = Number(selectedTransaction.payable || 0);
    const received = Number(convertReceived || 0);
    const due = payable - received;

    const payload = {
      estimate_id: selectedTransaction.id,
      // Customer
      cust_name: selectedTransaction.name || "",
      cust_address: selectedTransaction.address || "",
      cust_number: selectedTransaction.mobile || "",
      gstin: selectedTransaction.gstin || "",

      // Sale information
      date: selectedTransaction.date || new Date(),
      payable: Number(payable.toFixed(2)),
      recieved: Number(received.toFixed(2)),
      due: Number(due.toFixed(2)),

      // Existing transaction items
      items: selectedTransaction.items || [],

      // Payment
      mode: selectedTransaction.mode || "",
      payment_method: selectedTransaction.payment_method || "",

      // GST
      sgst: Number(selectedTransaction.sgst || 0),
      cgst: Number(selectedTransaction.cgst || 0),
      igst: Number(selectedTransaction.igst || 0),
      totalTax: Number(selectedTransaction.totalTax || 0),

      // Totals
      totalSP: Number(selectedTransaction.totalSP || 0),

      // Discount
      last_discount: Number(
        selectedTransaction.last_discount || 0
      ),

      last_discount_type:
        selectedTransaction.last_discount_type || "Amount",

      onChangeForDiscount: Number(
        selectedTransaction.onChangeForDiscount || 0
      ),

      // Client
      client_type: role,
    };

    console.log("FINAL CONVERT SALE PAYLOAD:", payload);

    const res = await axios.post(
      `https://api.dectwinbilling.com/convert-to-sale-bill/${clientData.id}`,
      payload
    );

    // console.log("CONVERT SALE RESPONSE:", res.data);

    showSuccess("Sale Invoice created successfully");

    setShowConvertModal(false);

    setSelectedTransaction(null);
    setConvertReceived("");
    setConvertDue(0);


     fetchEstimateHis();

  } catch (error) {
    console.error(
      "Convert sale error:",
      error.response?.data || error
    );

    showError(
      error.response?.data?.message ||
      "Failed to create sale invoice"
    );
  }
};


  return (

  <>
         <div className="container-fluid py-4">
      <div className="card shadow border-0 rounded-4">
     <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
  <h4 className="mb-0 fw-bold">
   All  Estimate
  </h4>

  <button className="btn btn-primary"
    onClick={() => navigate("/home")}
  >
    Back
  </button>
</div>
       

        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover align-middle text-center">
              <thead >
                <tr>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Inv.No</th>
                    <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Customer Name</th>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Customer Number</th>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Date </th>
           <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Total </th>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Activity</th>
                </tr>
              </thead>

  <tbody>
                   {filteredData.length === 0 ? (
        <tr>
          <td colSpan="8" className="text-center text-muted">
            No Transaction Found
          </td>
        </tr>
      ) : (
        filteredData.map((item, index) => (
          <tr key={item.id}>
            <td>{item.invoiceNo}</td>
            <td>{item.name}</td>
            <td>{item.mobile} </td>
            <td>{item.date}</td>
            <td> ₹{item.payable || 0}</td>
            
        <td> 

           <button className="btn btn-primary me-2" 
              onClick={() => handleOpenConvertSale(item)}
           >
         Convert To Sale
          </button>
        </td>
          </tr>
        ))
      )}
              </tbody>
        
            </table>
          </div>
        </div>

        {showConvertModal && (
  <div
    className="modal d-block"
    tabIndex="-1"
    style={{
      backgroundColor: "rgba(0,0,0,0.5)"
    }}
  >
    <div className="modal-dialog modal-lg">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title">
            Convert Transaction To Sale
          </h5>

          <button
            type="button"
            className="btn-close"
            onClick={() => setShowConvertModal(false)}
          />
        </div>

        <div className="modal-body">

          {/* Customer */}
          <div className="row">

            <div className="col-md-6 mb-3">
              <label className="form-label">
                Customer Name
              </label>

              <input
                type="text"
                className="form-control"
                value={selectedTransaction?.name || ""}
                readOnly
              />
            </div>

            {/* Mobile */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Mobile
              </label>

              <input
                type="text"
                className="form-control"
                value={selectedTransaction?.mobile || ""}
                readOnly
              />
            </div>

    
            {/* Date */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Date
              </label>

              <input
                type="text"
                className="form-control"
                value={selectedTransaction?.date || ""}
                readOnly
              />
            </div>

         
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Payable Amount
              </label>

              <input
                type="number"
                className="form-control"
                value={selectedTransaction.payable}
                
              />
            </div>

          <div className="col-md-4 mb-3">
  <label className="form-label">
    Received Amount
  </label>

  <input
    type="number"
    className="form-control"
    value={convertReceived}
    onChange={(e) => {
      const received = Number(e.target.value || 0);
      const payable = Number(selectedTransaction?.payable || 0);

      setConvertReceived(e.target.value);

      setConvertDue(payable - received);
    }}
  />
</div>


           <div className="col-md-4 mb-3">
  <label className="form-label">
    Due Amount
  </label>

  <input
    type="number"
    className="form-control"
    value={Number(convertDue || 0).toFixed(2)}

    readOnly
  />
</div>

          </div>

        </div>

        <div className="modal-footer">

          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowConvertModal(false)}
          >
            Cancel
          </button>

          <button
            type="button"
            className="btn btn-success"
            onClick={handleConvertToSale}
          >
            Convert To Sale
          </button>

        </div>

      </div>
    </div>
  </div>
)}

      </div>

 </div>
    </>
  )
}

export default ConvertToSsle
